import {FormGroup} from '@angular/forms';

export class WizardStep {
    public active: boolean;
    public groupTitle: string;
    public groupButtonName: string;

    private steps: WizardStep[] = [];

    constructor(
        public title: string,
        public form?: FormGroup,
        private buttonName?: string,
    ) {

    }

    setSteps(steps: WizardStep[]) {
        this.steps = steps;
    }

    setActiveStatus(status: boolean = true) {
        if (status) {
            /**
             * Делаем шаг активным, а остальные неактивными
             */
            this.steps.forEach(s => s.active = s === this);
        } else {
            this.active = false;
        }
    }

    setTouched() {
        if (!this.form) {
            return;
        }
        this.form.get('_touched').patchValue(true);
    }

    get touched(): boolean {
        return this.form && this.form.get('_touched') && Boolean(this.form.get('_touched').value);
    }

    get valid(): boolean {
        return this.form && this.form.valid;
    }

    get visible(): boolean {
        if (this.form && this.form.contains('_visible')) {
            return Boolean(this.form.get('_visible').value);
        }
        return true;
    }

    get buttonLabel(): string {
        return `${this.groupButtonName ? this.groupButtonName + ': ' : ''}${this.buttonName || this.title}`;
    }

    get nextStep(): WizardStep {
        for (let i = this.steps.indexOf(this) + 1; i < this.steps.length; i++) {
            if (this.steps[i].visible) {
                return this.steps[i];
            }
        }
        return null;
    }

    get prevStep(): WizardStep {
        for (let i = this.steps.indexOf(this) - 1; i >= 0; i--) {
            if (this.steps[i].visible) {
                return this.steps[i];
            }
        }
        return null;
    }
}
